import React, { useEffect, useState } from "react";
import calendarIconW from "../../images/calendar-icon_w.png";
import clockIconW from "../../images/clock-icon_w.png";
import cameraIcon from "../../images/icon-camera.png";
import FireOnMenu from "./FireOnMenu";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { apiWrapper } from "../../apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { getDate, getDateTime, getTime } from "../../utils/date";
import { API_HOST } from "../../Constants";
import { FireAlarmHistoryResultChoices, getFireAlarmHistoryResultName } from "../../utils/common";
import PageHeader from "../PageHeader";

export default function FireAlarmLogReportComponent() {
  const navigate = useNavigate();
  const { historyId } = useParams();
  const location = useLocation();
  const { buildingName } = location.state;
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    setFormDataProperty("id", "");
    setFormDataProperty("eventTime", "");
    setFormDataProperty("description", "");
    setFormDataProperty("confirmedDate", "");
    setFormDataProperty("confirmedTime", "");
    setFormDataProperty("confirmer", "");
    setFormDataProperty("contact", "");
    setFormDataProperty("action", "");
    setFormDataProperty("resultType", "1");
    setFormDataProperty("images", [])

    apiWrapper(async () => {
      const { status, data } = await fireonApi.getFireAlarmHistory(historyId);
      if (status === true) {
        setFormDataProperty("id", data.id);
        setFormDataProperty("eventTime", data.eventTime);
        setFormDataProperty("description", data.description);
        setFormDataProperty("confirmedDate", data.confirmedAt ? getDate(new Date(data.confirmedAt)) : "");
        setFormDataProperty("confirmedTime", data.confirmedAt ? getTime(new Date(data.confirmedAt)) : "");
        setFormDataProperty("confirmer", data.confirmer);
        setFormDataProperty("contact", data.contact);
        setFormDataProperty("action", data.action);
        setFormDataProperty("resultType", data.resultType === "" ? "1" : data.resultType);

        const newImageFiles = await Promise.all(data.images.map(async (item) => {
          //이미지 URL -> Blob 변환
          try {
            const response = await fetch(API_HOST + item.image);
            if (!response.ok) {
              throw new Error(`${response.status}`);
            }

            const blob = await response.blob();
            const file = new File([blob], item.imageFilename, { type: blob.type });
            return file;
          } catch (error) {
            console.error("이미지 URL을 Blob 객체로 변환 실패 : ", error)
          }
        }))
        setFormDataProperty("images", newImageFiles);


      } else {
        alert(`${data}`);
      }
    });
  }, []);

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    if (e.target.type === 'file') {
      const newFiles = e.target.files;
      if (newFiles.length > 0) {
        setFormDataProperty("images", [...formData.images, ...newFiles]);
      }
    } else {
      let name = e.target.name;
      let value = e.target.value;
      setFormDataProperty(name, value);
    }
  };

  const handleDeleteFile = (e) => {
    setFormDataProperty("images", formData.images.filter(item => item !== e));
  }

  const handleSave = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const requestBody = new FormData();
        if (formData.images.length > 0) {
          formData.images.map((file) => {
            requestBody.append("images", file);
          });
        }
        requestBody.append("payload",
          JSON.stringify({
            confirmedAt: new Date(`${formData.confirmedDate} ${formData.confirmedTime}`),
            confirmer: formData.confirmer,
            contact: formData.contact,
            action: formData.action,
            resultType: formData.resultType,
          }));

        const { status, data } = await fireonApi.updateFireAlarmHistory(historyId, requestBody);
        alert(`${data}`);

        if (status === true) {
          //성공 시 뒤로가기
          navigate(-1);
        }
      });
    }
  }

  const checkValid = () => {
    return true;
  }

  return (
    <section id="darkMode" class="mbSection darkMode pb-per">
      <PageHeader isBlack={true} title={buildingName} isUseMenu={true} />
      <form onSubmit={handleSave}>
        <div class="container pb-70">
          <p class="tableTitle mt-24 mb-20 pb-10 bb-w">
            화재경보 발생 보고서 작성
          </p>
          {formData && (
            <div class="input-wrap">
              <div class="input-item">
                <p class="input-title">관리 ID</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput readonlyInput"
                    type="text"
                    value={formData.id}
                    readonly
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">발생일시</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput readonlyInput"
                    type="text"
                    value={getDateTime(new Date(formData.eventTime))}
                    readonly
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">발생내역</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput readonlyInput"
                    type="text"
                    value={formData.description}
                    readonly
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">확인일시</p>
                <div class="input-inner-wrap datetime-wrap">
                  <div class="datetime-field">
                    {/* <img src={calendarIconW} class="input-icon" alt="달력" /> */}
                    <input
                      type="date"
                      name="confirmedDate"
                      value={formData.confirmedDate}
                      onChange={onChange}
                      required
                    />
                  </div>
                  <div class=" datetime-field time-field">
                    {/* <img src={clockIconW} class="input-icon" alt="시계" /> */}
                    <input
                      type="time"
                      name="confirmedTime"
                      value={formData.confirmedTime}
                      onChange={onChange}
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">확인자</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="확인자"
                    name="confirmer"
                    value={formData.confirmer}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">연락처</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="연락처를 입력해주세요."
                    name="contact"
                    value={formData.contact}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">확인조치사항</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    placeholder="확인 조치 사항"
                    name="action"
                    value={formData.action}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">결과 구분</p>
                <div class="radio-group">
                  {Object.values(FireAlarmHistoryResultChoices).map((item, index) => (
                    <>
                      <input
                        type="radio"
                        id={`resultType${item}`}
                        name="resultType"
                        value={item}
                        checked={formData.resultType === item}
                        onChange={onChange}
                      />
                      <label htmlFor={`resultType${item}`}>
                        {getFireAlarmHistoryResultName(item)}
                      </label>
                    </>
                  ))}
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">첨부사진</p>
                <div class="file-upload-wrap">
                  <label for="fileInput" class="btn-file">
                    <img src={cameraIcon} alt="카메라 아이콘" />
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    name="images"
                    onChange={onChange}
                    multiple
                    hidden
                  />

                  {formData.images.length > 0 ? (
                    formData.images.map((item, index) => (
                      <>
                        <span class="file-name" id="fileName">
                          {item.name}
                        </span>
                        <button
                          type="button"
                          class="btn-remove"
                          id="removeBtn"
                          // style={{ display: "none" }}
                          onClick={() => handleDeleteFile(item)}
                        >
                          <i class="x-icon"></i>
                        </button>
                      </>
                    ))
                  ) : (
                    <span class="file-name" id="fileName">
                      선택된 파일 없음
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div class="btmBtnWrap">
          <button type="button" class="btn btn-grey" onClick={() => navigate(-1)}>취소</button>
          <button type="submit" class="btn btn-white">저장</button>
        </div>
      </form>
      <FireOnMenu />
    </section >
  );
}
